'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = require('react-redux');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var companyProfile = _ref.companyProfile;
	return {
		name: companyProfile.name,
		talentPools: companyProfile.talentPools,
		satisfactionRate: companyProfile.buyerScorecard.get('satisfactionRate'),
		avgTimeToPayWorkInDays: companyProfile.buyerScorecard.get('avgTimeToPayWorkInDays'),
		avgTimeToApproveWorkInDays: companyProfile.buyerScorecard.get('avgTimeToApproveWorkInDays')
	};
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(_template2.default);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'src/components/WMCompanyPageTalentPools/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageTalentPools/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMCompanyPageTalentPools/index.js
// module id = jtaW
// module chunks = 62 63